import * as React from "react"
const DownLoadPdfIcon = (props:React.SVGProps<SVGSVGElement>) => (

    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 26 27"
    fill="none"
    {...props}
  >
 <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.333 12.417 13 17.833l-4.333-5.416h3.25V4.833h2.166v7.584h3.25ZM4.333 20h17.334v-7.583h2.166V20a2.169 2.169 0 0 1-2.166 2.167H4.333A2.169 2.169 0 0 1 2.167 20v-7.583h2.166V20Z"
      clipRule="evenodd"
    />
  </svg>
)
export default DownLoadPdfIcon

